import React from 'react';
import Image, { ImageLoaderProps } from 'next/legacy/image';
import { convertCloudinaryImage } from '../../../utils/cloudinary/cloudinary-image-url-processor';
/** This is a wrapper to work around NextJS's mishandling of Cloudinary's
 *  transformation API syntax.
 */

type Props = {
  src: string;
  altText?: string;
  layout?: any;
  objectFit?: any;
  format?: string;
  width?: number;
  height?: number;
  sizes?: string; // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-sizes
  id?: string;
};
/** Splits the full Cloudinary URL we receive from the Contentful query,
 *  inserts the proper Cloudinary params then serves the URL to the
 *  image tag so the image loads with the transformations properly applied.
 */
function cloudinaryImageUrlProcessor(props: ImageLoaderProps): string {
  return convertCloudinaryImage(props.src, props.width, props.quality);
}

export default function ImageComponent({
  src,
  altText,
  layout = `fill`, // default to fill mode. TODO: support `fixed` layout
  objectFit = `cover`,
  width,
  height,
  sizes = ``, // if no directive specified, next/image will default to 100vw
  id,
}: Props) {
  if (!src) {
    return null;
  }

  return (
    <Image
      loader={cloudinaryImageUrlProcessor}
      src={src}
      alt={altText}
      layout={layout}
      objectFit={objectFit}
      width={width ? width : undefined}
      height={height ? height : undefined}
      sizes={sizes}
      id={id}
    />
  );
}

// src: string;
// width: number;
// quality?: number;
